import React from "react";
import AIModuleSubtopic from "../AIModuleSubtopic";

const PropositionalLogicIntro = () => (
  <AIModuleSubtopic
    title="Introduction to Logic and Reasoning-Propositional Logic"
    videos={[
      "https://www.youtube.com/embed/9iN3O_oL2ac",
      "https://www.youtube.com/embed/YoE4BEc3lCk"
    ]}
    takeaways={[
      { text: "Understand the fundamentals of propositional logic and its role in AI reasoning." },
      { text: "Learn to formalize puzzles and real-world scenarios using logical expressions and truth tables." }
    ]}
    questions={[
      {
        text: "Three chests are presented to you. One contains a treasure map, and the other two are empty. Each box has imprinted on it a clue as to its contents; the clues are: Chest 1 'The treasure map is not here' Chest 2 'The treasure map is not here' Chest 3 'The treasure map is in Chest 2' Only one message is true; the other two are false. Which box has the treasure map? Formalize the puzzle in Propositional Logic and find the solution using a truth table"
      },
      {
        text: "Which of the following are entailed by the given sentence (A||B)&(7C||7D||E)? Justify with suitable rules/laws i) (A||B||C)&(B||C||D=>E) ii) (A||B)&(7D||E) (|| means or, & means and, 7 means not)"
      },
      {
        text: "Consider the following propositional logic statement: P->(Q&R) i)Prove that the statement P->(Q&R) is logically equivalent to (7P||Q)&(7P||R) using laws of inference. ii) Determine whether the statement (7P||Q)&(7P||R) is a tautology, satisfiable, or a contradiction."
      },
      {
        text: "Construct the Truth table for ((P->Q)->R)->S"
      },
      {
        text: "Consider the Wumpus world shown below: Assume the following knowledge base of the agent.(1,1) → (2,1) → (1,1) → (1,2) → (1,3) → (1,2) → (2,2) → (3,2) Convert the Knowledge base into propositional logic sentences. Show by resolution that, in the given situation, cell (1,4) contains a Wumpus and (3,2) contains a Gold.",
        image:"/ai_37.png"
      },
      {
        image:"/ai_38.png"
      },
      
      {
        text: "Consider the following sentence [(F=>P) and (D=>P)]=>[(F and D)=>P] a.Determine whether this sentence is valid, satisfiable (but not valid), or unsatisfiable, using enumeration. b.Convert the left-hand and right-hand sides of the main implications into CNF, showing each step, and explain how the results confirm your answer to (a). c.Prove your answer to (a) using resolution."
      },
      {
        text: "Consider the following set of sentences as a Knowledge Base (KB): Perumal likes all kinds of snacks. Samosa and sandwich are snacks. Perumal eats idly and is still alive. Anything eaten by anyone and is still alive is snack. (i) Convert this KB into First Order Logic. (ii) Now, convert this First Order Logics in Conjunctive Normal Form (CNF)"
      },
      {
        text: "Consider the following sentence: (Rain implies Wet Floor) OR (Dew implies Wet Floor) implies ((Rain AND Dew) implies Wet Floor) (i) Convert the following into propositional logic. (ii) Determine whether this sentence is valid, satisfiable (but not valid), or unsatisfiable? (iii) Convert the left-hand and right-hand sides of the main implications into CNF."
      },
      {
        text: "A knowledge base has the following statements: i.If there is gas in the tank and the fuel line is okay, then there is gas in the engine; ii. If there is gas in the engine and there is either a good spark or electronic ignition, the engine runs; iii. If there is power to the plugs or alternate battery charge is present, a good spark is produced; iv. If the battery is charged and the cables are okay, then there is power to the plugs. Convert the rules above to CNF using appropriate proposition symbols such as GasInTank, FuelLineOK, GasInEngine, etc."
      },
      {
        text: "Convert these statements to Predicate Logic format. i.People can fool some of the people all of the time. ii. Everyone in the world is loved by at least one person iii. There is at most one child"
      },
      {
        text: "Prove that (P&Q)->(PVR) is a Tautology using Truth Table"
      },
      {
        text: "Discuss the limitations of Predicate logic as a tool for Knowledge representation."
      },
      {
        text: "Identify the knowledge-type that is easy to represent with semantic network representation. Represent the following knowledge with semantic network structure. a) Every animal is a living thing. b) Every bird is an animal. c) Every bird flies. d) Every bird has 2 legs. e) Every mammal is an animal. f) Every mammal has 4 legs. g) Penguin is a bird. h) Cat is a mammal. i) Bats are mammals. j) Bats have 2 legs. k) Opus is a special-species of Penguin. 1) Bill is cat. m) Pat is a bat."
      },
      {
        text: "There are three students, Anjali, Braian, and Chenna. One of them is a topper. When asked, they said the following. Anjali: 'I am not the topper.' Braian: 'I am not the topper.' Chenna: 'Braian is the topper.' If only one person is telling the truth; Who is the topper? Formalize the puzzle in Propositional Logic and find the solution using a truth table."
      },
      {
        text: "Explain how Modus Ponen and Modus Tollens can be used to infer logic with a real world example."
      },
      {
        text: "Given the following propositional logic formula: (P∧Q)→(R→S) 1) Determine whether this sentence is valid, satisfiable (but not valid), or unsatisfiable. Justify your answer with laws used for inference. 2) Convert the given sentence into CNF, showing each step."
      }
    ]}
    exampleVideos={[]}
  />
);

export default PropositionalLogicIntro;
